import * as React from 'react';
import { useState } from 'react';
import { Link} from "react-router-dom";
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Spinner,Dropdown } from "react-bootstrap";
import Select from "react-select";
import {projectPhaseColors, projectStatusColors} from "../data/ProjectStatusColor";
import {propertyStatusColor} from "../data/PropertyStatusColor";
import Country from "../classes/Country";
import SelectWrp from "../components/SelectWrp";
import atlasApi from "../utils/atlasapi";
import DialogPropertyAttribute from "../layouts/DialogPropertyAttribute";
import DialogAssociateOwner from "../layouts/DialogAssociateOwner";
import { PencilSimple, DotsThreeVertical, UserCirclePlus, Book, Plus, X} from "@phosphor-icons/react";
import DoNowButton from "../components/DoNowButton";
import DialogOwner from "../layouts/DialogOwner";
import globalContext from "../utils/globalContext";
import {isObject} from "../utils/functions";

class PanelLand extends React.Component {
	//	scenario
	//	project
	//	scenarios
	//	selectedScenario
	//	onSelectScenario
	//	onDelete
	//	onSave
	//	onDuplicate
	
	
	constructor(props) {
		super(props);
		
		this.state ={
			previous:[],
			attributes:[],
			attributeDialog:{open:false},
			associateDialog:{open:false},
			ownerDialog:{open:false},
		}
		//this.ownersGlobal: this.props.ownersGlobal
		var self = this;
	}
	

	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
		this.forceUpdate();
	}
	

	handleClose(e){
		
		if(this.props.hasChanges){
			e.preventDefault();
			this.props.onClose(()=>{window.location.href=e.target.parentNode.href});
		}

	}

	componentDidUpdate(prevProps) {
		var self = this;
		if(!this.props.land)
			return;
		if(!prevProps.land || (this.props.land && this.props.land.id !== prevProps.land.id)){
			
			
			Promise.all(this.refreshPromises()).then((responses)=>{
				self.updateStatus({previous:responses[0], attributes:responses[1]});
			});
			
		}
	}
	componentDidMount(){
		var self = this;
		Promise.all(this.refreshPromises()).then((responses)=>{
			self.updateStatus({previous:responses[0], attributes:responses[1]});
		});
	}
	refreshPromises(){
		return [
			this.props.land.properties.propertyid ? atlasApi.getPropertyPreviousOwners(this.props.land.properties.propertyid) : [],
			this.props.land.properties.propertyid ? atlasApi.getPropertyAttributes(this.props.land.properties.propertyid) : []
		];
	}
	addAttribute(){
		
		this.updateStatus({attributeDialog:{open:true}});
	}
	editAttribute(attribute){
		
		this.updateStatus({attributeDialog:{open:true, item:attribute}});
	}
	closeAttributeDialog(){
		this.updateStatus({attributeDialog:{open:false}});
	}
	closeAssociateDialog(){
		this.updateStatus({associateDialog:{open:false}});
	}
	openAssociateDialog(vindrId){
		
		const {dialogs, getters} = this.props.context;
		
		//find vindrid in the owners list
		
		
		this.props.workMode.obj.openAssociateDialog(vindrId);
		
//		dialogs.setAssocDialog({
//			open:true,
//			onNoResults: (needle)=>{return this.handleNoResults(needle);},
//			onSelect: (owner)=>{this.handleSelectOwner(owner);}
//			
//		});
		
		
	}
	openOwnerDialog(setup){
		const {dialogs} = this.props.context;
		dialogs.setEditOwner({
			...setup, 
			...{
				onSave : (owner)=>{this.handleNewOwner(owner);}
			}
		});
	}
	openDetatchDialog(setup){
		const {dialogs} = this.props.context;
		dialogs.setDisassocProp({
			...setup, 
			...{
				onDelete : this.props.workMode.obj.handleDissassociate
			}
		});
	}
	closeOwnerDialog(){
		this.updateStatus({ownerDialog:{open:false, owner:null}});
	}
	
	
	handleSubmitAttribute(data){
		
		
		atlasApi[data.attribute_id ? 'setPropertyAttributes' : 'newPropertyAttribute'](data, this.props.land.properties.propertyid).then((res)=>{
			var swap = this.state.attributes.slice(0);
			
			if(!data.attribute_id)
				swap.push(res);
				
			else{
				var idx = swap.findIndex((a)=>{return a.attribute_id == data.attribute_id});
				
				if(idx != -1){
					swap[idx] = data;
				}	
			}
			
			this.updateStatus({attributes:swap});
			
		});
		
	}
	handleFetchOwner(owner, vindrId){
		
		const {QN} = this.props.context;
		
		this.props.workMode.obj.handleFetchOwner(owner, vindrId);
		
//		var newOwner = [];
//		owner.forEach((i)=>{
//			if(!i.fullName)
//				i.fullName = i.companyName ? i.companyName : i.firstName+' '+i.lastName;
//			
////			if(this.ownersGlobal.findIndex((idx)=>{return idx.id == i.id})==-1){
////				newOwner.push(i);
////			}
//				
//			return i; 
//		});
//		//this.ownersGlobal = [...this.ownersGlobal, ...newOwner]});
//		
//		var newScenario  = {...this.props.tc.scenario};
//
//		
//		newScenario.landowners =  [...owner, ...newScenario.landowners];
//
//
//		atlasApi.getPropertyBB(this.props.land.properties.vindrid).then((results)=>{
//			if(results && results.geometry){
//				
//				var newLand = {...this.props.land, ...results}
//				
//				if(!Array.isArray(newLand.properties.ownerid))
//					newLand.properties.ownerid = [];
//
//				newLand.properties.ownerid = [...newLand.properties.ownerid, ...owner.map((a)=>a.id)];
//				newLand.properties.color = owner[0].color ? owner[0].color : process.env.REACT_APP_PLOT_NO_OWNER_COLOR;			
//									
//				newScenario.properties.features =  [ ...[newLand], ...newScenario.properties.features];
//				
//				
//				
//				this.props.setLand(newLand);	
//				
//				if(this.props.workMode.obj.refreshMap)
//					this.props.workMode.obj.refreshMap(newScenario, newLand);
//				
//				
//				this.props.tc.setScenario(newScenario);
//				this.props.setOwners(newScenario.landowners);	
//			}
//			
//		});
//		
//		owner.forEach((i)=>{
//			QN.current.show(i.fullName+" was assigned as owner to property "+this.props.land.properties.vindrid);
//		});

	}
	handleSelectOwner(owner){
		
		var newLand = this.props.land;
		newLand.id = newLand.properties.vindrid;
		owner.properties = [];
		owner.properties.push(newLand);
		owner.totalArea = 0;
		owner.turbines = 0;
		owner.dialogs = [];
		
		//this.props.changePropertyOwner(newLand.properties.vindrid, owner.id, {}, owner);
		
		this.handleFetchOwner([owner], newLand.properties.vindrid);
		this.closeAssociateDialog();
	}
	handleNoResults(needle){
		
		var swap = needle.split(" ");
		var temp = {firstName:swap.slice(0, -1).join(" "), lastName:swap[swap.length-1]};
		
		
		return <Button className="btn-land-actions" onClick={(e)=>{this.updateStatus({ownerDialog:{open:true, owner:temp}});}}><Plus size={16} /> Create new owner "{needle}"</Button>
	}
	handleNewOwner(owner){
		
		this.closeOwnerDialog();
		
		this.handleSelectOwner(owner);
		
		
	}
	deleteAttribute(data){
		
		
		atlasApi.deleteAttribute(data.attribute_id, this.props.land.properties.propertyid).then((res)=>{
			var swap = this.state.attributes.slice(0);
			

			var idx = swap.findIndex((a)=>{return a.attribute_id == data.attribute_id});

			if(idx != -1){
				swap.splice(idx, 1);
			}	this.updateStatus({attributes:swap});	
		});
		
	}
	
	render(){
		if(this.props.land && this.props.land.id !== false) {
			
			const land = this.props.land;
			const tc = this.props.tc;
						
			var lo = land.properties.ownerid ?? land.properties.landownerid  ?? [];
			
			
			if(!Array.isArray(lo))
				lo = [lo];
			
			//filter out unknown plots with id temp_xxx
			var landOwners = lo.filter((i)=>{return (!isNaN(i) || isObject(i));});
			

			
			return (
				<>
					<div className={"project-land "} key={this.props.land.id}>
						<div className="title">
							{land.properties.vindrid}
							<span onClick={()=>{this.props.setLand(null); this.props.clear(); this.props.clearAll(false); this.props.workMode.obj.clear();}} className="btn btn-close btn-sm float-end"><X size={16} /></span>
						</div>
						<div className="separator">
							<span>About this property</span>
							<Button onClick={()=>{this.addAttribute();}} variant="btn p7 ms-auto"><Plus size="16" /></Button>
						</div>
						<div className="content attributes">
							{this.props.workMode.obj.propertyAttributes(land, landOwners)}
							
							{
								this.state.attributes.map((a)=>{
									return (
										<Row className="basic-info mb-2">
											<Col xs="12 property-attribute">
												<div className="key">
													<i className="ri-flip-horizontal-line mr-2"></i>
													<b>{a.key}: </b>
													
												</div>
												<div>
													<span>{a.value}</span>
													<Dropdown className="minimal">
														<Dropdown.Toggle variant="outline-primary"><DotsThreeVertical size={16} /></Dropdown.Toggle>
														<Dropdown.Menu>
															<Dropdown.Item href="#" onClick={(e)=>{this.editAttribute(a)}}><i className="ri-pencil-line"></i> Edit</Dropdown.Item>
															<Dropdown.Divider />
															<Dropdown.Item href="#" className="text-danger" onClick={(e)=>{this.deleteAttribute(a)}}><i className="ri-delete-bin-6-line"></i> Delete</Dropdown.Item>
														</Dropdown.Menu>
													</Dropdown>
												</div>
											</Col>
										</Row>
									)
								})
							}

						</div>

						<div className="separator">
							<span>Owners</span>
							{!!landOwners.length &&
							<Button onClick={(e)=>{this.openAssociateDialog(land.properties.vindrid);}} variant="btn p7 ms-auto"><Plus size="16" /></Button>
							}
							
						</div>
						<div className="container">
						
						{
							
							
							
							
							landOwners.map((ownerEnt, k)=>{
								var isComp = this.props.workMode.value == 'compensation' ? true : false;
								//ownerEnt can be int or obj
								var owner = null;
								if(Number.isInteger(ownerEnt)){
									owner = tc.scenario.landowners.find((o)=>o.id==ownerEnt);
									var ownerProp = owner.properties.find((p)=>p.id == land.properties.vindrid);
								}
								else {
									owner = ownerEnt;
									var ownerProp = land.properties;
								}
								
								if(!owner.id && !owner.ownerid)
									return '';
								
								return (
									<Row className="owner-info" key={k}>
										<Col xs={(isComp ? 11 : 7) + " pe-0 name"}  onClick={(e)=>{this.props.setLand(null); this.props.setOwner(owner);}}>
											<i className="ri-user-line me-2"></i> 
											<span>{owner.fullName}</span>
										</Col>
										{!isComp && 
										<Col xs="4 ps-0">
											{ownerProp && 
											<SelectWrp selected={ownerProp.status} onChange={this.props.changePropertyState} options={propertyStatusColor.asOptions()} extraParam={owner.landownerid ?? owner.id} propertyId={land.properties.vindrid}	/>
											}
										</Col>
										}
										<Col xs="1 ps-0 text-end">
											<Dropdown className="minimal">
												<Dropdown.Toggle variant="outline-primary"><DotsThreeVertical size={16} /></Dropdown.Toggle>
												<Dropdown.Menu>
													<Dropdown.Item href="#" onClick={(e)=>{this.openOwnerDialog({open:true, owner:owner})}}><i className="ri-pencil-line"></i> Edit owner</Dropdown.Item>
													<Dropdown.Divider />
													<Dropdown.Item href="#" onClick={(e)=>{this.openDetatchDialog({open:true, property:land.properties.vindrid, owner:owner})}} className="text-danger"><i className="ri-delete-bin-6-line"></i> Detach owner</Dropdown.Item>
												</Dropdown.Menu>
											</Dropdown>
											
										</Col>
									</Row>
								)
							})
						}
						{!landOwners.length &&
							<Row className="owner-info p-3 pt-4">

								{Country.canFetchOwners(this.props.projectData.country) && !['Norway'].includes(this.props.projectData.country) &&
									<>	<Col xs="1">
											<i className="ri-information-2-line text-danger"></i>
										</Col>
										<Col xs="11">
											<b>Please note:</b> Fetching landowner information in this country requires a fee
										</Col>
									</>
								}
								{Country.canFetchOwners(this.props.projectData.country) &&
								<Col xs="12 mt-4 p-0">
										<DoNowButton 
											iconIdle={<Book size={16} />}
											btnClassName="btn-land-actions land-book"
											onClick={()=>{
												return atlasApi.getPlotInfo([land.properties.vindrid], this.props.projectData.country);
											}}
											onFinish={(res)=>{
												if(res[land.properties.vindrid])
													this.handleFetchOwner(res[land.properties.vindrid], land.properties.vindrid);
											}}
											text={'Fetch owner from Land Book'}
										/>
								</Col>
								}
								<Col xs="12 mt-4 p-0">
									<Button className="btn-land-actions" onClick={(e)=>{this.openAssociateDialog(land.properties.vindrid);}}><UserCirclePlus size={16} /> Assign owner manually</Button>
								</Col>
							</Row>
						}
						</div>				
						{
							!!this.state.previous.length && <>
								<div className="separator">
									<span>Previous owners</span>

								</div>
								<div className="container">
								{
									this.state.previous.map((o, i)=>{

										return (
											<Row className="owner-info" key={i}>
												<Col xs="12 pe-0 name inactive">
													<i className="ri-user-line me-2"></i> 
													<span>{o.fullName}</span>
												</Col>
											</Row>
										)
									})
								}
								</div>
								</>

						}
					</div>
					<DialogPropertyAttribute setup={this.state.attributeDialog} attributes={this.state.attributes} onClose={()=>{this.closeAttributeDialog()}} onSubmit={(data)=>{this.handleSubmitAttribute(data)}} />
					
				</>
			)
		}
		return;
	}
} 
export default PanelLand;